import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export const usePageTracking = () => {
  const location = useLocation();
  const lastPage = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    // Don't track if same page
    if (lastPage.current === location.pathname) return;
    lastPage.current = location.pathname;

    // Track page view
    const trackPageView = async () => {
      try {
        await axios.post(`${API}/api/tracking/page-view`, {
          page_url: location.pathname,
          page_title: document.title,
          referrer: document.referrer
        }, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } catch (error) {
        // Silently fail - tracking shouldn't break the app
        console.debug('Page tracking failed:', error);
      }
    };

    trackPageView();
  }, [location]);

  // Heartbeat every 30 seconds to maintain online status
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    const heartbeat = async () => {
      try {
        await axios.post(`${API}/api/tracking/heartbeat`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } catch (error) {
        console.debug('Heartbeat failed:', error);
      }
    };

    // Initial heartbeat
    heartbeat();

    // Set up interval
    const interval = setInterval(heartbeat, 30000);

    return () => clearInterval(interval);
  }, []);
};

export default usePageTracking;
